"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import NoCoupon from "@/assets/images/account/no-coupons.webp";
import { PopLoading } from "@/components/pop-ui/pop-loading";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { useIsMobile } from "@/hooks/use-mobile";
import { useRouterPush } from "@/lib/utils.client";
import { CouponList } from "@/modules/coupon/components/coupon-list";
import { useUserCoupons } from "@/modules/coupon/data/coupon-queries";
import { sortCouponsWithNotStarted } from "@/modules/coupon/utils/coupon-sorting";
import Empty from "./components/empty";
import { ModulePagination } from "./components/module-pagination";
import { ModuleTabs } from "./components/module-tabs";
import { ModuleTitle } from "./components/module-title";
export function CouponsModule(t0) {
  const $ = _c(51);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    onHeaderContentChange
  } = t1;
  const {
    t
  } = useTranslation();
  const isMobile = useIsMobile();
  const [activeTab, setActiveTab] = useState("unused");
  const [currentPage, setCurrentPage] = useState(1);
  const routerPush = useRouterPush();
  let t2;
  if ($[2] !== t) {
    t2 = t("account.coupons.tabs.available");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = {
      key: "unused" as const,
      label: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t("account.coupons.tabs.history");
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      key: "expired" as const,
      label: t4
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = [t3, t5];
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const TABS = t6;
  let t7;
  if ($[13] !== activeTab) {
    t7 = activeTab === "expired" ? ["expired", "used"] : [activeTab];
    $[13] = activeTab;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const {
    data: couponData,
    isLoading,
    refetch
  } = useUserCoupons(t7, 1, 100);
  let t8;
  let totalPages;
  if ($[15] !== couponData?.items || $[16] !== currentPage) {
    const allCoupons = couponData?.items || [];
    const sortedAllCoupons = sortCouponsWithNotStarted(allCoupons);
    const totalItems = sortedAllCoupons.length;
    totalPages = Math.ceil(totalItems / 10);
    const startIndex = (currentPage - 1) * 10;
    const endIndex = startIndex + 10;
    t8 = sortedAllCoupons.slice(startIndex, endIndex);
    $[15] = couponData?.items;
    $[16] = currentPage;
    $[17] = t8;
    $[18] = totalPages;
  } else {
    t8 = $[17];
    totalPages = $[18];
  }
  const sortedCoupons = t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = page => {
      setCurrentPage(page);
    };
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const handlePageChange = t9;
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setCurrentPage(1);
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== activeTab) {
    t11 = [activeTab];
    $[21] = activeTab;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  useEffect(t10, t11);
  let t12;
  let t13;
  if ($[23] !== activeTab || $[24] !== isMobile || $[25] !== onHeaderContentChange || $[26] !== t) {
    t12 = () => {
      if (isMobile && onHeaderContentChange) {
        const headerContent = activeTab === "unused" ? <button type="button" onClick={() => setActiveTab("expired")} className="text-sm font-medium text-hint underline">{t("account.coupons.history", "History")}</button> : <button type="button" onClick={() => setActiveTab("unused")} className="text-sm font-medium text-hint underline">{t("account.coupons.back", "Back")}</button>;
        onHeaderContentChange(headerContent);
      }
    };
    t13 = [activeTab, isMobile, onHeaderContentChange, t];
    $[23] = activeTab;
    $[24] = isMobile;
    $[25] = onHeaderContentChange;
    $[26] = t;
    $[27] = t12;
    $[28] = t13;
  } else {
    t12 = $[27];
    t13 = $[28];
  }
  useEffect(t12, t13);
  let t14;
  if ($[29] !== refetch) {
    t14 = async () => {
      await refetch();
    };
    $[29] = refetch;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const handleRefresh = t14;
  let t15;
  if ($[31] !== TABS || $[32] !== activeTab || $[33] !== isMobile || $[34] !== t) {
    t15 = !isMobile && <><ModuleTitle title={t("account.coupons.title")} /><ModuleTabs tabs={TABS} activeKey={activeTab} onChange={key => setActiveTab(key as "unused" | "expired")} /></>;
    $[31] = TABS;
    $[32] = activeTab;
    $[33] = isMobile;
    $[34] = t;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  const desktopHeaderDom = t15;
  let t16;
  if ($[36] !== activeTab || $[37] !== couponData || $[38] !== currentPage || $[39] !== desktopHeaderDom || $[40] !== isLoading || $[41] !== isMobile || $[42] !== routerPush || $[43] !== sortedCoupons || $[44] !== t || $[45] !== totalPages) {
    t16 = () => {
      if (isLoading) {
        return <div className={isMobile ? "min-h-screen" : "min-h-[500px]"}>{desktopHeaderDom}<div className={`flex items-center justify-center py-8 ${isMobile ? "px-3" : ""}`}><PopLoading /></div></div>;
      }
      if (!couponData || !couponData.items || couponData.items.length === 0) {
        return <div className={isMobile ? "min-h-screen" : ""}>{desktopHeaderDom}<div className={isMobile ? "px-3 py-4" : ""}><Empty src={NoCoupon} title={t("account.coupons.emptyText")} /></div></div>;
      }
      return <>{desktopHeaderDom}<div className="w-full"><CouponList coupons={sortedCoupons as any} isFromHistoryTab={activeTab === "expired"} onShopNow={coupon => {
            routerPush(`/collection-coupons?couponId=${(coupon as any).couponTemplate?.id}`);
          }} /></div><div className={isMobile ? "px-3 pb-4" : ""}><ModulePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /></div></>;
    };
    $[36] = activeTab;
    $[37] = couponData;
    $[38] = currentPage;
    $[39] = desktopHeaderDom;
    $[40] = isLoading;
    $[41] = isMobile;
    $[42] = routerPush;
    $[43] = sortedCoupons;
    $[44] = t;
    $[45] = totalPages;
    $[46] = t16;
  } else {
    t16 = $[46];
  }
  const contentDom = t16;
  let t17;
  if ($[47] !== contentDom || $[48] !== handleRefresh || $[49] !== isMobile) {
    t17 = isMobile ? <div className="min-h-screen"><PullToRefreshWrapper onRefresh={handleRefresh}>{contentDom()}</PullToRefreshWrapper></div> : <div className={isMobile ? "min-h-screen" : ""}>{contentDom()}</div>;
    $[47] = contentDom;
    $[48] = handleRefresh;
    $[49] = isMobile;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  return t17;
}